import Config from "../Custom/Config";
String.prototype.toPersianUniCode = function () {
  return this.replaceAll(" ", "")
    .replaceAll("ی", "ي")
    .replaceAll("آ", "ا")
    .replaceAll("ۀ", "ه")
    .replaceAll("ة", "ه")
    .replaceAll("ؤ", "و")
    .replaceAll("إ", "ا")
    .replaceAll("أ", "ا")
    .replaceAll("ء", "و")
    .replaceAll("ك", "ک")
    .replaceAll("ڪ", "ک")
    .replaceAll("الله", "اله")
    .replaceAll("ا...", "اله");
};
export function signOut() {
  localStorage.clear();
  window.location.href = process.env.PUBLIC_URL + "/Login";
}
export function ApiServices(url, body = null, method) {
  const totalUrl = `${Config.APIRoot}/${url}`;
  const bodyDate = JSON.stringify(body || {});
  var myHeader = new Headers();
  myHeader.append("Content-Type", "application/json");
  myHeader.append("authorization", `Bearer ${localStorage.getItem("Ticket")}`);
  return fetch(totalUrl, {
    method: method,
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    redirect: "follow",
    referrer: "no-referrer",
    headers: myHeader,
    body: method == "POST" || method == "PUT" ? bodyDate : null,
  });
}
export function CallService(
  servicesUrl,
  obj,
  method,
  setIsLoading = null,
  hasLoading = false,
) {
  if (setIsLoading) {
    hasLoading ? setIsLoading(true) : setIsLoading(false);
  }
  return ApiServices(servicesUrl, obj, method)
    .then((response) => {
      try {
        if (response.status == 401 && localStorage.getItem("Ticket")) {
          signOut();
        } else if (response.status == 500) {
          const err = "با خطای غیر منتظره مواجه شدید ";
          setIsLoading(false);
          return err;
        } else {
          return response.text();
        }
      } catch {
        modalAlert("با خطای غیر منتظره مواجه شدید", "خطا");
      }
    })
    .then((responseTxt) => {
      try {
        return JSON.parse(responseTxt);
      } catch (e) {
        return {
          success: false,
          message: responseTxt,
        };
      }
    })
    .then((data) => {
      if (data) {
        if ("IsAuthenticated" in data && data.IsAuthenticated === false) {
          signOut();
        } else if (data.success === true) {
          return data;
        } else {
          return Promise.reject(data);
        }
      }
    });
}

// knowledgebase
export function ApiServicesExternal(serviceUrl, obj, method) {
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (method.toUpperCase() !== "GET" && method.toUpperCase() !== "HEAD") {
    options.body = JSON.stringify(obj);
  }

  return fetch(Config.ApiKhn + serviceUrl, options);
}

export function CallServiceExternal(
  servicesUrl,
  obj,
  method,
  setIsLoading = null,
  hasLoading = false,
) {
  if (setIsLoading) {
    hasLoading ? setIsLoading(true) : setIsLoading(false);
  }

  return ApiServicesExternal(servicesUrl, obj, method)
    .then((response) => {
      try {
        if (response.status === 401) {
          return Promise.reject({
            success: false,
            message: "Unauthorized",
          });
        } else if (response.status === 500) {
          if (setIsLoading) setIsLoading(false);

          return {
            success: false,
            message: "با خطای غیر منتظره مواجه شدید",
          };
        }

        return response.text();
      } catch {
        modalAlert("با خطای غیر منتظره مواجه شدید", "خطا");
      }
    })
    .then((responseTxt) => {
      try {
        return JSON.parse(responseTxt);
      } catch {
        return {
          success: false,
          message: responseTxt,
        };
      }
    })
    .then((data) => {
      if (Array.isArray(data)) {
        return data;
      }

      if (typeof data === "object" && data !== null && !("success" in data)) {
        return data;
      }

      if (data.success) {
        return data;
      }

      return Promise.reject(data);
    });
}

export function modalAlert(message, title, options) {
  //fazel
  // if (typeof enableControls == "function") {
  //     enableControls();
  // }
  //-fazel
  if (message && typeof message === "string")
    while (message.includes("\r\n")) message = message.replace("\r\n", "<br/>");
  if (typeof options != "object") {
    options = {};
  }
  if (options.delay != undefined) {
    options.delay++;
    options.delay--;
  } else {
    options.delay = 100;
  }
  if (!window.smile_alert) {
    var smile_obj = {
      selecter: "smile-modalAlert",
      element: null,
      filter: 30,
      cancelElement: null,
      confirmElement: null,
    };
    smile_obj.element = document.querySelector(smile_obj.selecter);
  } else {
    if (window.smile_alert.cancel) {
      window.smile_alert.cancelElement.style = "";
    }
    if (window.smile_alert.confirm) {
      window.smile_alert.confirmElement.style = "";
    }
    window.smile_alert.element.style.display = "block";
    smile_obj = window.smile_alert;
  }
  // document.querySelector("#dvContent").style.filter = "blur(2px)";
  // document.querySelector(".header").style.filter = "blur(2px)";
  smile_obj.cancel = options.cancel != undefined ? options.cancel : false;
  smile_obj.cancelText =
    options.cancelText != undefined ? options.cancelText : "انصراف";
  smile_obj.cancelCallBack = function (event) {
    window.smile_alert.cancelElement.style =
      "background-color:#999;color:#000;filter:alpha(opacity=" +
      window.smile_alert.filter +
      ");-moz-opacity:" +
      window.smile_alert.filter / 100 +
      ";-khtml-opacity: " +
      window.smile_alert.filter / 100 +
      ";opacity: " +
      window.smile_alert.filter / 100 +
      ";";
    setTimeout(function () {
      window.smile_alert.element.style.display = "none";
      if (typeof options.cancelCallBack == "function") {
        options.cancelCallBack(event);
      }
      return true;
    }, window.smile_alert.delay);
    // document.querySelector("#dvContent").style.filter = "none";
    // document.querySelector(".header").style.filter = "none";
  };
  smile_obj.closeCallBack = function () {
    window.smile_alert.cancelElement.style =
      "background-color:#999;color:#000;filter:alpha(opacity=" +
      window.smile_alert.filter +
      ");-moz-opacity:" +
      window.smile_alert.filter / 100 +
      ";-khtml-opacity: " +
      window.smile_alert.filter / 100 +
      ";opacity: " +
      window.smile_alert.filter / 100 +
      ";";
    setTimeout(function () {
      window.smile_alert.element.style.display = "none";
      return true;
    }, window.smile_alert.delay);
    // document.querySelector("#dvContent").style.filter = "none";
    // document.querySelector(".header").style.filter = "none";
  };
  smile_obj.message = message;
  smile_obj.title = title;
  smile_obj.confirm = options.confirm != undefined ? options.confirm : true;
  smile_obj.confirmText =
    options.confirmText != undefined ? options.confirmText : "متوجه شدم";
  smile_obj.confirmCallBack = function (event) {
    window.smile_alert.confirmElement.style =
      "background-color:#999;color:#04BE02;filter:alpha(opacity=" +
      window.smile_alert.filter +
      ");-moz-opacity:" +
      window.smile_alert.filter / 100 +
      ";-khtml-opacity: " +
      window.smile_alert.filter / 100 +
      ";opacity: " +
      window.smile_alert.filter / 100 +
      ";";
    setTimeout(function () {
      window.smile_alert.element.style.display = "none";
      if (typeof options.confirmCallBack == "function") {
        options.confirmCallBack(event);
      }
      return true;
    }, window.smile_alert.delay);
    // document.querySelector("#dvContent").style.filter = "none";
    // document.querySelector(".header").style.filter = "none";
  };
  if (!smile_obj.element) {
    smile_obj.html =
      '<div class="' +
      smile_obj.selecter +
      '" id="' +
      smile_obj.selecter +
      '">' +
      '<div class="' +
      smile_obj.selecter +
      '-mask"></div>' +
      '<div class="' +
      smile_obj.selecter +
      '-message-body">' +
      '<button class="' +
      smile_obj.selecter +
      '-message-button-close"><span>×</span ></button >' +
      '<div class="' +
      smile_obj.selecter +
      "-message-tbf " +
      smile_obj.selecter +
      '-message-title"><strong class="' +
      smile_obj.selecter +
      '-message-tbf ">' +
      smile_obj.title +
      "</strong></div>" +
      '<div class="' +
      smile_obj.selecter +
      "-message-tbf " +
      smile_obj.selecter +
      '-message-content">' +
      smile_obj.message +
      "</div>" +
      '<div class="' +
      smile_obj.selecter +
      "-message-tbf " +
      smile_obj.selecter +
      '-message-button">';
    if (smile_obj.cancel || true) {
      smile_obj.html +=
        '<a href="javascript:;" class="' +
        smile_obj.selecter +
        "-message-tbf " +
        smile_obj.selecter +
        '-message-button-cancel">' +
        smile_obj.cancelText +
        "</a>";
    }
    if (smile_obj.confirm || true) {
      smile_obj.html +=
        '<a href="javascript:;" class="' +
        smile_obj.selecter +
        "-message-tbf " +
        smile_obj.selecter +
        '-message-button-confirm">' +
        smile_obj.confirmText +
        "</a>";
    }
    smile_obj.html += "</div>" + "</div>" + "</div>";
    var element = document.createElement("div");
    element.id = smile_obj.selecter + "-wrap";
    element.innerHTML = smile_obj.html;
    document.body.appendChild(element);
    smile_obj.element = document.querySelector("." + smile_obj.selecter);
    smile_obj.cancelElement = document.querySelector(
      "." + smile_obj.selecter + "-message-button-cancel",
    );
    smile_obj.closeButton = document.querySelector(
      "." + smile_obj.selecter + "-message-button-close",
    );
    if (smile_obj.cancel) {
      document.querySelector(
        "." + smile_obj.selecter + "-message-button-cancel",
      ).style.display = "block";
    } else {
      document.querySelector(
        "." + smile_obj.selecter + "-message-button-cancel",
      ).style.display = "none";
    }
    smile_obj.confirmElement = document.querySelector(
      "." + smile_obj.selecter + "-message-button-confirm",
    );
    if (smile_obj.confirm) {
      document.querySelector(
        "." + smile_obj.selecter + "-message-button-confirm",
      ).style.display = "block";
    } else {
      document.querySelector(
        "." + smile_obj.selecter + "-message-button-confirm",
      ).style.display = "none";
    }
    smile_obj.cancelElement.onclick = smile_obj.cancelCallBack;
    if (!options.close) smile_obj.closeButton.display = "none";
    else smile_obj.closeButton.onclick = smile_obj.closeCallBack;
    smile_obj.confirmElement.onclick = smile_obj.confirmCallBack;
    window.smile_alert = smile_obj;
  }
  document.querySelector(
    "." + smile_obj.selecter + "-message-title",
  ).innerHTML = "";
  document.querySelector(
    "." + smile_obj.selecter + "-message-content",
  ).innerHTML = "";
  document.querySelector(
    "." + smile_obj.selecter + "-message-button-cancel",
  ).innerHTML = smile_obj.cancelText;
  document.querySelector(
    "." + smile_obj.selecter + "-message-button-confirm",
  ).innerHTML = smile_obj.confirmText;
  smile_obj.cancelElement = document.querySelector(
    "." + smile_obj.selecter + "-message-button-cancel",
  );
  smile_obj.closeButton = document.querySelector(
    "." + smile_obj.selecter + "-message-button-close",
  );
  if (smile_obj.cancel) {
    document.querySelector(
      "." + smile_obj.selecter + "-message-button-cancel",
    ).style.display = "block";
  } else {
    document.querySelector(
      "." + smile_obj.selecter + "-message-button-cancel",
    ).style.display = "none";
  }
  smile_obj.confirmElement = document.querySelector(
    "." + smile_obj.selecter + "-message-button-confirm",
  );
  if (smile_obj.confirm) {
    document.querySelector(
      "." + smile_obj.selecter + "-message-button-confirm",
    ).style.display = "block";
  } else {
    document.querySelector(
      "." + smile_obj.selecter + "-message-button-confirm",
    ).style.display = "none";
  }
  smile_obj.cancelElement.onclick = smile_obj.cancelCallBack;

  if (!options.close) smile_obj.closeButton.style.display = "none";
  else smile_obj.closeButton.onclick = smile_obj.closeCallBack;
  smile_obj.confirmElement.onclick = smile_obj.confirmCallBack;
  if (smile_obj.title && smile_obj.message) {
    document.querySelector(
      "." + smile_obj.selecter + "-message-title",
    ).innerHTML = smile_obj.title;
    if (
      message &&
      (message instanceof Element || message instanceof HTMLDocument)
    )
      document
        .querySelector("." + smile_obj.selecter + "-message-content")
        .appendChild(smile_obj.message);
    else
      document.querySelector(
        "." + smile_obj.selecter + "-message-content",
      ).innerHTML = smile_obj.message;
  } else if (smile_obj.message) {
    if (
      message &&
      (message instanceof Element || message instanceof HTMLDocument)
    )
      document
        .querySelector("." + smile_obj.selecter + "-message-content")
        .appendChild(smile_obj.message);
    else
      document.querySelector(
        "." + smile_obj.selecter + "-message-content",
      ).innerHTML = smile_obj.message;
  } else if (smile_obj.title) {
    document.querySelector(
      "." + smile_obj.selecter + "-message-title",
    ).innerHTML = smile_obj.title;
  }
  window.smile_alert = smile_obj;
}
export function formatDates(inputText, isBackspace) {
  const numbers = inputText.replace(/\D/g, "");

  if (isBackspace) {
    const updatedNumbers = numbers.slice(0, -1);
    let currentIndex = 0;
    const formattedText = "----/--/--"
      .split("")
      .map((char) => {
        if (char === "/") {
          return char;
        } else {
          const currentDigit = updatedNumbers[currentIndex];
          currentIndex++;
          return currentDigit || "-";
        }
      })
      .join("");
    return formattedText;
  }

  let index = 0;
  const formattedText = "----/--/--"
    .split("")
    .map((char) => {
      return char === "/" ? char : numbers[index++] || "-";
    })
    .join("");

  return formattedText;
}
var dkSolar = 0;
var dkGregorian = 1;
function IsLeapYear(DateKind, Year) {
  if (DateKind == dkSolar) return ((Year + 38) * 31) % 128 <= 30;
  else return Year % 4 == 0 && (Year % 100 != 0 || Year % 400 == 0);
}
var GREGORIAN_EPOCH = 1721425.5;
var PERSIAN_EPOCH = 1948320.5;
function mod(a, b) {
  return a - b * Math.floor(a / b);
}
export function persian_to_jd(year, month, day) {
  var epbase, epyear;

  epbase = year - (year >= 0 ? 474 : 473);
  epyear = 474 + mod(epbase, 2820);
  return (
    day +
    (month <= 7 ? (month - 1) * 31 : (month - 1) * 30 + 6) +
    Math.floor((epyear * 682 - 110) / 2816) +
    (epyear - 1) * 365 +
    Math.floor(epbase / 2820) * 1029983 +
    (PERSIAN_EPOCH - 1)
  );
}
export function gregorian_to_jd(year, month, day) {
  return (
    GREGORIAN_EPOCH -
    1 +
    365 * (year - 1) +
    Math.floor((year - 1) / 4) +
    -Math.floor((year - 1) / 100) +
    Math.floor((year - 1) / 400) +
    Math.floor(
      (367 * month - 362) / 12 +
        (month <= 2 ? 0 : IsLeapYear(dkGregorian, year) ? -1 : -2) +
        day,
    )
  );
}
export function jd_to_persian(jd) {
  var year, month, day, depoch, cycle, cyear, ycycle, aux1, aux2, yday;

  jd = Math.floor(jd) + 0.5;

  depoch = jd - persian_to_jd(475, 1, 1);
  cycle = Math.floor(depoch / 1029983);
  cyear = mod(depoch, 1029983);
  if (cyear == 1029982) {
    ycycle = 2820;
  } else {
    aux1 = Math.floor(cyear / 366);
    aux2 = mod(cyear, 366);
    ycycle =
      Math.floor((2134 * aux1 + 2816 * aux2 + 2815) / 1028522) + aux1 + 1;
  }
  year = ycycle + 2820 * cycle + 474;
  if (year <= 0) {
    year--;
  }
  yday = jd - persian_to_jd(year, 1, 1) + 1;
  month = yday <= 186 ? Math.ceil(yday / 31) : Math.ceil((yday - 6) / 30);
  day = jd - persian_to_jd(year, month, 1) + 1;
  return new Array(year, month, day);
}
export function GregorianToSolar(gy, gm, gd) {
  if (gd == 0 && gm == 0 && gy == 0) {
    var dDate = new Date();
    gd = dDate.getDate();
    gm = dDate.getMonth() + 1;
    gy = dDate.getFullYear();
  }
  var g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  var jy = gy <= 1600 ? 0 : 979;
  gy -= gy <= 1600 ? 621 : 1600;
  var gy2 = gm > 2 ? gy + 1 : gy;
  var days =
    365 * gy +
    parseInt((gy2 + 3) / 4) -
    parseInt((gy2 + 99) / 100) +
    parseInt((gy2 + 399) / 400) -
    80 +
    gd +
    g_d_m[gm - 1];
  jy += 33 * parseInt(days / 12053);
  days %= 12053;
  jy += 4 * parseInt(days / 1461);
  days %= 1461;
  jy += parseInt((days - 1) / 365);
  if (days > 365) days = (days - 1) % 365;
  var jm =
    days < 186 ? 1 + parseInt(days / 31) : 7 + parseInt((days - 186) / 30);
  var jd = 1 + (days < 186 ? days % 31 : (days - 186) % 30);

  this.gYear = jy;
  this.gMonth = ("00" + jm).substr(-2);
  this.gDay = ("00" + jd).substr(-2);
  this.getDate = function () {
    return this.gDay;
  };
  this.getMonth = function () {
    return this.gMonth;
  };
  this.getYear = function () {
    return this.gYear;
  };
  this.getFullYear = function () {
    return this.gYear;
  };
  this.getFormatedDate = function () {
    return `${this.gYear}/${this.gMonth}/${this.gDay}`;
  };
  this.getDaysInMonth = function () {
    return this.gMonth < 7
      ? 31
      : this.gMonth < 12
        ? 30
        : this.isLeapYear()
          ? 30
          : 29;
  };
  this.isLeapYear = function () {
    return (
      (this.gYear % 4 === 0 && this.gYear % 100 !== 0) || this.gYear % 400 === 0
    );
  };
}

export function formatDate(serverTime) {
  if (!serverTime) return null;
  var timeStamp = serverTime;
  if (serverTime.toString().includes(")"))
    timeStamp = timeStamp.substring(
      serverTime.lastIndexOf("(") + 1,
      serverTime.lastIndexOf(")"),
    );
  var dateTime = new Date(timeStamp);
  var gDateTime = new GregorianToSolar(
    dateTime.getFullYear(),
    dateTime.getMonth() + 1,
    dateTime.getDate(),
  );
  var year = gDateTime.getFullYear();
  var month = gDateTime.getMonth();
  var date = gDateTime.getDate();
  var hour = dateTime.getHours();
  var min = dateTime.getMinutes();
  var sec = dateTime.getSeconds();

  var dateString = year + "/" + month + "/" + date;
  var timeString = hour + ":" + min + ":" + sec;
  return [dateString, timeString];
}
String.prototype.padLeft = function (n, pad) {
  var t = "";
  if (n > this.length) {
    for (var i = 0; i < n - this.length; i++) {
      t += pad;
    }
  }
  return t + this;
};
String.prototype.toElements = function () {
  return new DOMParser().parseFromString(this, "text/html").body.childNodes;
};

export function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(null);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    }
  });
}
export const getAllCompany = (stDepartments, stOrganization) => {
  const deps = Array.isArray(stDepartments) ? stDepartments : [];
  const orgs = Array.isArray(stOrganization) ? stOrganization : [];

  if (localStorage.getItem("refType") === "false") {
    return [...deps, ...orgs].filter(Boolean);
  }

  return deps.filter(Boolean);
};
// export const getAllCompany = (stDepartments, stOrganization) => {
//   let company = [];
//   if (localStorage.getItem("refType") === "false") {
//     return company.concat(stDepartments, stOrganization);
//   } else {
//     if (stDepartments) {
//       var Dep = [stDepartments[4]];
//       return Dep;
//     }
//   }
// };
export function decodeToken(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
}

export function InstallOrGetServiceWorker() {
  return new Promise((resolve, reject) => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg) return resolve(reg);
        else
          navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL}/serviceWorker.js`)
            .then((reg) => {
              return resolve(reg);
            });
      });
    }
  });
}

// ---------------------------- print ----------------------------
//function getHtmlDomByURL(URL, convertToHtml = true) {
//    return API.get(URL)
//        .then(content => {
//            if (convertToHtml) {
//                var parser = new DOMParser();
//                var doc = parser.parseFromString(content, 'text/html');
//                newBody = doc.body;
//                var HTMLDOM = document.createElement("div");
//                for (var i = 0; i < newBody.childNodes.length; i++) {
//                    var node = newBody.childNodes[i];
//                    var elem = node.tagName ? document.createElement(node.tagName) : document.createTextNode(node.data);
//                    if (node.attributes)
//                        for (var j = 0; j < node.attributes.length; j++) {
//                            var attr = node.attributes[j];
//                            if (attr)
//                                elem.setAttribute(attr.name, attr.value);
//                        }
//                    elem.innerHTML = node.innerHTML ? node.innerHTML : node.data;
//                    HTMLDOM.appendChild(elem);
//                }
//                return Promise.resolve(HTMLDOM);
//            }
//            return Promise.resolve(content);
//        })
//        .catch(err => {
//            return Promise.reject(err)
//        });
//}

//function PrintElem(elem) {
//    var container = document.createElement('div');
//    container.className = "printIframeContainer";
//    var IFRM = document.createElement("iframe");
//    IFRM.className = "printIframe";
//    IFRM.src = "about:blank";
//    IFRM.onload = function () {
//        resizeIFrameToFitContent(IFRM);
//        var ifrmdoc = (IFRM.document || IFRM.contentDocument);
//        var ifrmwin = IFRM.contentWindow;
//        if (ifrmdoc) {
//            ifrmdoc.write(eval('`' + elem + '`'));
//            ifrmdoc.querySelector('img').onload = () => {
//                ifrmwin.print();
//            }
//            ifrmwin.onafterprint = function () {
//                container.remove();
//                setTimeout(() => { hideLoader(); }, 0);
//            }
//        }
//    }
//    container.appendChild(IFRM);
//    document.body.appendChild(container);
//    return true;
//}
//----------------------------------------------------------------

export function getFileType(file) {
  const fileType = file.name.split(".").pop().toLowerCase();
  if (["jpg", "jpeg", "png", "bmp"].includes(fileType)) {
    return "image";
  } else if (fileType === "pdf") {
    return "pdf";
  } else if (fileType === "xlsx") {
    return "excel";
  }
  return "unsupported";
}
//export function handleFileUpload(Myfile, callback) {
//    let filesArr = Myfile.map((file) => {
//        if (file) {
//            const reader = new FileReader();
//            reader.onload = function (e) {
//                const fileType = getFileType(file); // Get the file type
//                switch (fileType) {
//                    case 'image':
//                        handleImage(file, e.target.result, callback);
//                        break;
//                    case 'excel':
//                        handleExcel(file, e.target.result, callback);
//                        break;
//                    case 'pdf':
//                        handlePDF(file, e.target.result, callback);
//                        break;
//                    default:
//                        console.error('فایل مورد نظر پشتیبانی نمیشود.');
//                }
//            };
//            reader.readAsDataURL(file); // Read the file as a data URL
//        } else {
//            console.error("No file selected.");
//        }
//    });
//}
export function handleFileUpload(files, callback) {
  let promises = [];
  if (files.length) {
    files.forEach((file) => {
      //conver to MB...
      var fileSize = file.size / (1024 * 1024);
      //if smaller than 3 MB condition happen...
      if (fileSize <= 50) {
        if (file) {
          promises.push(
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = function (e) {
                resolve({ name: file.name, data: e.target.result }); // Resolve with object containing file name and binary data
              };
              reader.readAsArrayBuffer(file); // Read file as binary data
            }),
          );
        } else {
          console.error("No file selected.");
        }
      } else {
        return false;
      }
    });
  }
  Promise.all(promises)
    .then((fileDataArray) => {
      callback(fileDataArray); // Pass an array of objects containing file names and binary data to the callback
    })
    .catch((error) => {
      console.error(error);
    });
}

// Handler for image files
export function handleImage(file, dataURL, callback) {
  const image = new Image();
  image.onload = function () {
    // Do any image processing if needed
    if (callback && typeof callback === "function") {
      callback(file); // Invoke the callback function with the file
    }
  };
  image.src = dataURL;
}

// Handler for Excel files
export function handleExcel(file, dataURL, callback) {
  // Perform actions specific to Excel files if needed
  if (callback && typeof callback === "function") {
    callback(file); // Invoke the callback function with the file
  }
}

// Handler for PDF files
function handlePDF(file, dataURL, callback) {
  // Perform actions specific to PDF files if needed
  if (callback && typeof callback === "function") {
    callback(file); // Invoke the callback function with the file
  }
}
